
const LocationIcon = ({ size = 18, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`inline-block align-middle ${className}`}
    >
      <path
        d="M12 22s8-7.5 8-13a8 8 0 1 0-16 0c0 5.5 8 13 8 13z"
        fill="black"
      />

      <circle cx="12" cy="9" r="3" fill="white" />
    </svg>
  );
};

export default LocationIcon;